import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { AuthGuard } from './guards/auth.guard';
import { DirtyCheckGuard } from './guards/dirty-check.guard';
import { GlobalService } from './services/global.service';
import { LandingComponent } from './components/landing/landing.component';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CookieHandler } from './handlers/cookie-handler';
import { InterceptorHandler } from './handlers/interceptor-handler';
import { SharedModule } from '../shared/shared.module';
import { MainComponent } from './components/main/main.component';
import { RouterModule } from '@angular/router';
import { AuthService } from '../auth/services/auth.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ChangePasswordModalComponent } from './components/change-password-modal/change-password-modal.component';
import { SessionInactivityModalComponent } from './components/session-inactivity-modal/session-inactivity-modal.component';
import { ConcurrentUserSessionModalComponent } from './components/concurrent-user-session-modal/concurrent-user-session-modal.component';
import { PrivacyStatementModalComponent } from './components/privacy-statement-modal/privacy-statement-modal.component';
import { PrivacyStatementPageComponent } from './components/privacy-statement-page/privacy-statement-page.component';
import { StorageHandler } from './handlers/storage-handler';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    LandingComponent,
    MainComponent,
    ChangePasswordModalComponent,
    SessionInactivityModalComponent,
    ConcurrentUserSessionModalComponent,
    PrivacyStatementModalComponent,
    PrivacyStatementPageComponent,
  ],
  imports: [CommonModule, SharedModule, HttpClientModule, RouterModule, NgxSpinnerModule],
  exports: [HeaderComponent, FooterComponent, MainComponent, LandingComponent, HttpClientModule, NgxSpinnerModule],
  providers: [AuthGuard, DirtyCheckGuard, StorageHandler, GlobalService, AuthService, CookieHandler, { provide: HTTP_INTERCEPTORS, useClass: InterceptorHandler, multi: true }],
})
export class CoreModule { }
